module.exports = __webpack_public_path__ + "static/media/logo-xpdconnect-blanco.a1b513ad.svg";